var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",class:{ 'spinner--design-new': _vm.design === 'new' }})
}
var staticRenderFns = []

export { render, staticRenderFns }